import React from "react";
import { PatientDocumentContentItem } from "../messages/PatientDocuments";
import { If } from "./Generic/If";
import { RequiredDocAnswerableQuestionProps } from "./RequiredDocAnswerableQuestion";
import RequiredDocShortText from "./RequiredDocShortText";
import { RequiredDocSignature } from "./RequiredDocSignature";

interface RequiredDocCustomSignature extends RequiredDocAnswerableQuestionProps {
  item: PatientDocumentContentItem;
  getNameAnswer: (questionId: number) => string | null | undefined;
  showErrors: boolean;
  hideName: boolean;
}

const CustomSignature = (props: RequiredDocCustomSignature) => {
  if (props.item.columns === undefined || props.item.columns === null) {
    throw new Error(`Custom signature item ${props.questionId} has no child element`);
  }

  const child = props.item.columns[0][0];
  const nameAnswer = props.getNameAnswer(child.id);
  const isChildValid =
    props.isRequired && props.showErrors
      ? nameAnswer !== null && nameAnswer !== undefined && nameAnswer !== ""
      : true;

  return (
    <>
      <If condition={!props.hideName}>
        <div style={{ margin: "8px 16px" }}>
          <RequiredDocShortText
            currentAnswer={nameAnswer}
            handleOnInsertAnswer={props.handleOnInsertAnswer}
            isRequired={props.isRequired}
            isValid={isChildValid}
            questionId={child.id}
            questionText={props.questionText + " - Full Name"}
            prefilledAnswer={props.prefilledAnswer}
            notes={null}
            readonly={props.readonly}
          />
        </div>
      </If>

      <div style={{ margin: "8px 16px" }}>
        <RequiredDocSignature
          type={"Custom"}
          handleOnInsertAnswer={props.handleOnInsertAnswer}
          readonly={props.readonly}
          isRequired={props.isRequired}
          isValid={props.isValid}
          questionText={props.questionText}
          prefilledAnswer={props.prefilledAnswer}
          questionId={props.questionId}
          notes={props.notes}
          currentAnswer={props.currentAnswer}
          allowUnsigned={false}
        />
      </div>
    </>
  );
};

// Do not use React.memo here until you fix the mutable props.
export default CustomSignature;
